export type Parser<T> = (value: string | null, defaultValue: T) => T;

export const toNumber: Parser<number> = (value, defaultValue) => (value ? parseInt(value, 10) : defaultValue);
